export function getBaseIconButtonStyle(theme) {
    return {
        icon: {
            margin: "0px",
        },
        root: {
            // backgroundColor must be overriden for IconButton because the Fluent UI IconButton component does not use semanticColors.
            backgroundColor: theme.customSemanticColors.controlFillDefault,
            // color must be overriden for IconButton because the Fluent UI IconButton uses theme color for icons.
            color: theme.customSemanticColors.textPrimary,
            height: "40px",
            width: "40px",
        },
        rootHovered: {
            // backgroundColor must be overriden for IconButton because the Fluent UI IconButton component does not use semanticColors.
            backgroundColor: theme.customSemanticColors.controlFillSecondary,
            // color must be overriden for IconButton because the Fluent UI IconButton uses theme color for icons.
            color: theme.customSemanticColors.textPrimary,
        },
        rootPressed: {
            // backgroundColor must be overriden for IconButton because the Fluent UI IconButton component does not use semanticColors.
            backgroundColor: theme.customSemanticColors.controlFillTertiary,
            // color must be overriden for IconButton because the Fluent UI IconButton uses theme color for icons.
            color: theme.customSemanticColors.textSecondary,
        },
    };
}
